import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ReactComponent as CloseIcon } from '../assets/close.svg';

interface Props {
  className?: string;
  onClose(): void;
}

export function Close({ className, onClose }: Props): JSX.Element {
  const { classes, cx } = useStyles();

  return (
    <button
      type="button"
      onClick={onClose}
      className={cx(classes.container, className)}
    >
      <CloseIcon />
    </button>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    padding: 0,
    width: 36,
    height: 36,
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: '0.3s',
    color: alpha(theme.palette.common.black, 0.5),
    border: `1px solid ${alpha(theme.palette.grey[900], 0.1)}`,
    borderRadius: '50%',

    '&:hover': {
      color: theme.palette.common.black,
      border: `1px solid ${alpha(theme.palette.grey[900], 0.3)}`,
    },
  },
}));
